import { useCallback } from 'react'

import { useAppDispatch } from '../../../store'
import * as sidebarActions from '../../../store/modules/sidebar'
import { ChatType } from '../../chats'
import { SidebarOptionKind } from '../../layout/sidebar/types'
import { FriendlyDateTime } from '../Date/friendly-date-time'
import { Toast } from '../NarusMaterial'

interface MessageToastProps {
  id: string
  author?: {
    name?: [
      {
        given?: string[]
        family?: string[]
        suffix?: string[]
      }
    ]
  }
  clientName: string
  close: (id: string) => void
  chatId: string
  message: string
  createdAt: string
  patientId: string
  isConcierge?: boolean
}

export function MessageToast ({ id, author, clientName, close, isConcierge, chatId, message, createdAt, patientId }: MessageToastProps): JSX.Element {
  const dispatch = useAppDispatch()

  const handleClose = useCallback((): void => {
    close(id)
  }, [ close, id ])

  function handleCardClick (): void {
    dispatch(sidebarActions.open(SidebarOptionKind.messages))
    dispatch(sidebarActions.selectTab(isConcierge ? ChatType.Concierge : ChatType.Own))
    dispatch(sidebarActions.selectChat(chatId))
  }

  return (
    <Toast
      onDelete={handleClose}
    >
      <Content
        onClick={handleCardClick}
        author={author}
        message={message}
        createdAt={createdAt}
      />
    </Toast>
  )
}

interface ContentProps {
  author: MessageToastProps['author']
  message: string
  createdAt: string
  onClick: () => void
}

function Content ({ author, message, createdAt, onClick }: ContentProps): JSX.Element {
  let name = 'Unknown Sender'

  if (author?.name?.[0]) {
    const first = author.name[0].given?.[0] ?? ''
    const last = author.name[0].family?.[0] ?? ''
    const suffix = author.name[0]?.suffix?.join(', ') ?? ''
    name = `${first} ${last} ${suffix}`
  }

  return (
    <button
      className='cursor-pointer'
      onClick={onClick}
    >
      <p className='line-clamp-2 text-sm break-all'>
        {message}
      </p>

      <span className='time'>
        {name} on <FriendlyDateTime datetime={createdAt} />
      </span>
    </button>
  )
}
